// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-font-color: #3a3a3a;
  --primary-color: #ec7765;
  --secondary-color: #92278f;
  --text-gray-color: #aaaaaa;
  --text-grayBtn-color: #EEEEEE;
  --text-darkgray-color: #7A7A7A;
  --hover-color: #d0566e;
  --background-color: #fff;
  --background-header-color: #a23588;
  --success-green-color: #17A300;
  --error-red-color: #D40D0D;
  --main-btn:#da6770 ;
}

* {
  font-family: "DM Sans" !important;
}

.home-page-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.scrollable-div::-webkit-scrollbar {
  width: 0.2em;
}

.scrollable-div::-webkit-scrollbar-track {
  background-color: white;
}

.scrollable-div::-webkit-scrollbar-thumb {
  background-color: lightgray;
}

.react-datepicker-wrapper input {
  border: 1px solid #bbb7b6;
  color: #181415;
  border-radius: 8px;
  padding: 6px 10px 5px 10px !important;
}

.react-datepicker__calendar-icon {
  right: 8px;
  padding: 10px 0px !important;
}

.react-datepicker__navigation {
  border-radius: 4px !important;
  top: 8px !important;
  margin: 0 5px !important;
}

.react-datepicker__navigation--previous {
  background-color: #ebebeb !important;
  width: 20px !important;
  height: 20px !important;
}

.react-datepicker__navigation--next {
  background-color: #ebebeb !important;
  width: 20px !important;
  height: 20px !important;
}

/* Style the arrows' icon (color: blue) */
.react-datepicker__navigation--previous::before,
.react-datepicker__navigation--next::before {
  color: blue !important;
}

/* Style the day button (blue background) */
.react-datepicker__day--in-range {
  background-color: #ebebeb !important;
  color: black !important;
  border-radius: 0px !important;
}

/* Style the selected date */
.react-datepicker__day--selected,
.react-datepicker__day--range-start,
.react-datepicker__day--range-end,
.react-datepicker__day--keyboard-selected {
  background-color: #1c3c74 !important;
  color: white !important;
  border-radius: 0px !important;
}

.react-datepicker__day--range-start {
  border-top-left-radius: 8px !important;
  border-bottom-left-radius: 8px !important;
}

.react-datepicker__day--range-end {
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}

.react-datepicker__navigation-icon {
  top: 4px !important;
}

.react-datepicker__navigation-icon--previous {
  right: 1px !important;
}

.react-datepicker__navigation-icon--next {
  left: 1px !important;
}

.react-datepicker__header {
  background-color: white !important;
  border: none !important;
}

.react-datepicker__current-month {
  color: #181415 !important;
  font-weight: normal !important;
}

.react-datepicker__month-container {
  border-left: none !important;
}

.react-datepicker {
  border: none !important;
  border-radius: 0px !important;
}

.progress-bar-bg-success {
  background-image: linear-gradient(to right, rgba(28, 152, 8, 0.6), rgb(28, 152, 8));
}

.progress-bar-bg-warning {
  background-image: linear-gradient(to right, rgba(255, 143, 40, 0.6), rgb(255, 143, 40));
}

.progress-bar-bg-danger {
  background-image: linear-gradient(to right, rgba(224, 25, 25, 0.6), rgb(224, 25, 25));
}

.custom-modal .modal-content {
  width: 660px;
}

.custom-date-picker .react-datepicker {
  border: 1px solid #aeaeae !important;
  border-radius: 0.3rem !important;
}

.success-modal .modal-content {
  max-width: 350px !important;
  text-align: center;
}

.success-modal .modal-dialog {
  display: flex;
  justify-content: center;
}

input[type=radio] {
  accent-color: teal;
}

.message-modal .modal-content {
  max-width: 400px !important;
}

.button-main-12 {
  width: fit-content;
}

@keyframes rotateBorder {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAGA;EACE,6BAAA;EACA,wBAAA;EACA,0BAAA;EACA,0BAAA;EACA,6BAAA;EACA,8BAAA;EACA,sBAAA;EACA,wBAAA;EACA,kCAAA;EACA,8BAAA;EACA,0BAAA;EAEA,mBAAA;AAFF;;AAIA;EACE,iCAAA;AADF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAFF;;AAIA;EACE,YAAA;AADF;;AAGA;EACE,uBAAA;AAAF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,qCAAA;AACF;;AACA;EACE,UAAA;EACA,4BAAA;AAEF;;AAAA;EACE,6BAAA;EACA,mBAAA;EACA,wBAAA;AAGF;;AADA;EACE,oCAAA;EACA,sBAAA;EACA,uBAAA;AAIF;;AADA;EACE,oCAAA;EACA,sBAAA;EACA,uBAAA;AAIF;;AADA,yCAAA;AACA;;EAEE,sBAAA;AAIF;;AADA,2CAAA;AACA;EACE,oCAAA;EACA,uBAAA;EACA,6BAAA;AAIF;;AADA,4BAAA;AACA;;;;EAIE,oCAAA;EACA,uBAAA;EACA,6BAAA;AAIF;;AAFA;EACE,sCAAA;EACA,yCAAA;AAKF;;AAHA;EACE,uCAAA;EACA,0CAAA;AAMF;;AAJA;EACE,mBAAA;AAOF;;AALA;EACE,qBAAA;AAQF;;AANA;EACE,oBAAA;AASF;;AAPA;EACE,kCAAA;EACA,uBAAA;AAUF;;AARA;EACE,yBAAA;EACA,8BAAA;AAWF;;AATA;EACE,4BAAA;AAYF;;AAVA;EACE,uBAAA;EACA,6BAAA;AAaF;;AAXA;EACE,mFAAA;AAcF;;AARA;EACE,uFAAA;AAWF;;AALA;EACE,qFAAA;AAQF;;AAFA;EACE,YAAA;AAKF;;AAHA;EACE,oCAAA;EACA,gCAAA;AAMF;;AAJA;EACE,2BAAA;EACA,kBAAA;AAOF;;AALA;EACE,aAAA;EACA,uBAAA;AAQF;;AANA;EACE,kBAAA;AASF;;AAPA;EACE,2BAAA;AAUF;;AARA;EACE,kBAAA;AAWF;;AARA;EACE;IACE,uBAAA;EAWF;EATA;IACE,yBAAA;EAWF;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;700&display=swap');\n\n\n:root { \n  --primary-font-color: #3a3a3a;\n  --primary-color: #ec7765;\n  --secondary-color: #92278f;\n  --text-gray-color: #aaaaaa;\n  --text-grayBtn-color: #EEEEEE;\n  --text-darkgray-color: #7A7A7A;\n  --hover-color: #d0566e;\n  --background-color: #fff;\n  --background-header-color: #a23588;\n  --success-green-color: #17A300;\n  --error-red-color: #D40D0D;\n\n  --main-btn:#da6770\n}\n*{\n  font-family: 'DM Sans' !important;\n}\n\n\n.home-page-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n.scrollable-div::-webkit-scrollbar {\n  width: 0.2em;\n}\n.scrollable-div::-webkit-scrollbar-track {\n  background-color: white;\n}\n.scrollable-div::-webkit-scrollbar-thumb {\n  background-color: lightgray;\n}\n\n.react-datepicker-wrapper input {\n  border: 1px solid #bbb7b6;\n  color: #181415;\n  border-radius: 8px;\n  padding: 6px 10px 5px 10px !important;\n}\n.react-datepicker__calendar-icon {\n  right: 8px;\n  padding: 10px 0px !important;\n}\n.react-datepicker__navigation {\n  border-radius: 4px !important;\n  top: 8px !important;\n  margin: 0 5px !important;\n}\n.react-datepicker__navigation--previous {\n  background-color: #ebebeb !important;\n  width: 20px !important;\n  height: 20px !important;\n}\n\n.react-datepicker__navigation--next {\n  background-color: #ebebeb !important;\n  width: 20px !important;\n  height: 20px !important;\n}\n\n/* Style the arrows' icon (color: blue) */\n.react-datepicker__navigation--previous::before,\n.react-datepicker__navigation--next::before {\n  color: blue !important;\n}\n\n/* Style the day button (blue background) */\n.react-datepicker__day--in-range {\n  background-color: #ebebeb !important;\n  color: black !important;\n  border-radius: 0px !important;\n}\n\n/* Style the selected date */\n.react-datepicker__day--selected,\n.react-datepicker__day--range-start,\n.react-datepicker__day--range-end,\n.react-datepicker__day--keyboard-selected {\n  background-color: #1c3c74 !important;\n  color: white !important;\n  border-radius: 0px !important;\n}\n.react-datepicker__day--range-start {\n  border-top-left-radius: 8px !important;\n  border-bottom-left-radius: 8px !important;\n}\n.react-datepicker__day--range-end {\n  border-top-right-radius: 8px !important;\n  border-bottom-right-radius: 8px !important;\n}\n.react-datepicker__navigation-icon {\n  top: 4px !important;\n}\n.react-datepicker__navigation-icon--previous {\n  right: 1px !important;\n}\n.react-datepicker__navigation-icon--next {\n  left: 1px !important;\n}\n.react-datepicker__header {\n  background-color: white !important;\n  border: none !important;\n}\n.react-datepicker__current-month {\n  color: #181415 !important;\n  font-weight: normal !important;\n}\n.react-datepicker__month-container {\n  border-left: none !important;\n}\n.react-datepicker {\n  border: none !important;\n  border-radius: 0px !important;\n}\n.progress-bar-bg-success {\n  background-image: linear-gradient(\n    to right,\n    rgba(28, 152, 8, 0.6),\n    rgba(28, 152, 8, 1)\n  );\n}\n.progress-bar-bg-warning {\n  background-image: linear-gradient(\n    to right,\n    rgba(255, 143, 40, 0.6),\n    rgba(255, 143, 40, 1)\n  );\n}\n.progress-bar-bg-danger {\n  background-image: linear-gradient(\n    to right,\n    rgba(224, 25, 25, 0.6),\n    rgba(224, 25, 25, 1)\n  );\n}\n.custom-modal .modal-content {\n  width: 660px;\n}\n.custom-date-picker .react-datepicker {\n  border: 1px solid #aeaeae !important;\n  border-radius: 0.3rem !important;\n}\n.success-modal .modal-content {\n  max-width: 350px !important;\n  text-align: center;\n}\n.success-modal .modal-dialog {\n  display: flex;\n  justify-content: center;\n}\ninput[type=\"radio\"] {\n  accent-color: teal;\n}\n.message-modal .modal-content {\n  max-width: 400px !important;\n}\n.button-main-12{\n  width: fit-content;\n}\n\n@keyframes rotateBorder {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
